module.exports = __webpack_public_path__ + "static/media/Woman.cce1ae0e.png";